import React from 'react'
import { TreeItem } from '@material-ui/lab';


const CustomTreeItem = React.forwardRef((props:any,ref:any) => {
  return (
    <TreeItem ref={ref} {...props}> {props.children}  </TreeItem>
  )
});

export default CustomTreeItem;